<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CovhhD/tc-custom/9781466844247.jpg?1731883537562" alt="This image is the cover for the book Frozen Dead, Commandant Martin Servaz"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Frozen Dead, Commandant Martin Servaz
      </h1>
      <p class="bookDescription body article font2">
        <b>A French cop and a young psychiatrist must untangle a perplexing murder in this “tense and disturbing” mystery debut—now a series on Netflix (<i>Booklist</i>, starred review).</b><br/><br/>Saint-Martin-de-Comminges is a remote village nestled in the French Pyrenees, where winters are harsh and nothing ever happens. Until one morning when a group of workers discover the headless, flayed body of a horse, hanging suspended from the edge of a frozen cliff.<br/><br/>That same day, just a few miles away, psychiatrist Diane Berg starts her first job at an asylum for the criminally insane. She is baffled by the director’s unorthodox methods, and alarmed to discover that drugs are disappearing from within its fortified walls.<br/><br/>Commandant Martin Servaz, a charismatic city cop from nearby Toulouse, can’t believe he’s been called to such a backwater town over the death of an animal. But then DNA from one of the asylum’s most notorious inmates is found on the horse carcass . . . and a few days later the first human victim is found.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bernard Minier
      </h2>
      
      <p class="authorDescription body article">BERNARD MINIER grew up in the foothills of the French Pyrenees. He had a career as a customs official before publishing his first novel, <I>The Frozen Dead</I>, in 2011. The novel has been translated into a dozen languages and has garnered critical acclaim as well as several literary prizes in France. Minier lives in the Essonne, south of Paris.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Minotaur
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7868ab96